import {
  TRANSIT_STOP_AMENITIES_VALUES,
  TRANSIT_STOP_AMENITIES,
  HIGH_CAPACITY_TRANSIT_FACILITY_VALUES,
  HIGH_CAPACITY_TRANSIT_FACILITY,
  HCT_AMENITIES_VALUES,
  HCT_AMENITIES
} from '../constants/transit'

export const transitConfig = [
  {
    name: 'Transit Stop Amenities',
    id: TRANSIT_STOP_AMENITIES,
    inputType: 'checkBox',
    required: true,
    scores: [],
    inputValues: TRANSIT_STOP_AMENITIES_VALUES,
    notes:
      'Select all amenities that are present at the "weakest" bus stop along the corridor. A score of 3 or greater requires sign/identifier and continuous sidewalk, plus at least one other amenity.'
  },
  {
    name: 'High-Capacity Transit Facility',
    id: HIGH_CAPACITY_TRANSIT_FACILITY,
    inputType: 'dropDown',
    required: true,
    scores: [],
    inputValues: HIGH_CAPACITY_TRANSIT_FACILITY_VALUES,
    notes: 'Select high-capacity transit facility.'
  },
  {
    name: 'High-Capacity Transit Amenities',
    id: HCT_AMENITIES,
    inputType: 'checkBox',
    required: true,
    scores: null,
    inputValues: HCT_AMENITIES_VALUES,
    notes: 'Select all applicable amenities.'
  },
  {
    name: 'Volume/Capacity Ratio',
    id: 'vc',
    autoPopulated: true,
    inputType: 'number',
    required: true,
    scores: null,
    notes:
      'Volume/capacity ratio, or V/C, is calculated using the traffic volume chosen in the project setup on the previous page, and the Capacity Assumption value from the Auto inputs. It is a ratio of how much available space on the road is currently being used by vehicles.'
  },
  {
    name: 'High Capacity Transit',
    id: 'high_capacity_transit',
    inputType: 'string',
    required: true,
    scores: null,
    notes: 'Value populated in project setup on previous page.',
    autoPopulated: true
  },
  {
    name: 'Transit Tier',
    id: 'tier',
    inputType: 'string',
    required: true,
    scores: null,
    notes: 'Value populated in project setup on previous page.',
    autoPopulated: true
  },
  {
    name: 'Land Use Context',
    id: 'land_use_context',
    inputType: 'string',
    required: true,
    scores: null,
    notes: 'Value populated in project setup on previous page.',
    autoPopulated: true
  }
]
